<template>
    <div class="page-container">
        <div class="d-flex justify-content-between">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler"
                         to="/settings/entities">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                Edit Entity
            </router-link>
            <SaveBtn @save="submitHandler"/>
        </div>

        <div id="createEntityContainer" class="tabcontent my-3">
            <div class="entity-section row m-0 p-0 d-flex justify-content-between my-3">

                <div class="col-lg-5 col-md-4 col-sm-5">
                    <label>Entity Name <span style="color: #E95626">*</span></label>
                    <input class="custom-input form-control w-50" type="text"
                           @change="changeHandler"
                           autocomplete="off"
                           @input="changeHandler($event,index)"
                           v-model="name" name="entityName"/>

                    <div class="err errorEntityName" v-if="errors['name'].length > 0">
                        <div v-for="msg in errors['name']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="col-lg-5 col-md-4 col-sm-5">
                    <label>Assign to <span style="color: #E95626">*</span></label>
                    <Multiselect
                            v-model="parent_id"
                            :options="options"
                            ref="multiselect"
                            class="multiselect-style"
                            @change="selectHandler"
                    />

                    <div class="err errorEntityName" v-if="errors['parent'].length > 0">
                        <div v-for="msg in errors['parent']" class="text-danger">{{msg}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <AlartModal v-if="showModal" :message="message" imagePath="okImage.svg"
                @close-modal="showModal = false"/>
    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
                @close-modal="showErrorModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import SaveBtn from '../../components/SaveBtn';
    import {computed, defineAsyncComponent} from "vue";

    import repository from "../../../api-services/repository";

    import Multiselect from '@vueform/multiselect';

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    const AlartModal = defineAsyncComponent(() =>
        import ('../../components/AlartModal')
    );
    export default {
        name: 'setting-entity-edit',
        components: {
            SaveBtn,
            AlartModal,
            ConfirmationModal,
            Multiselect
        },
        data() {
            return {
                id: null,
                isFull: false,
                isError: false,
                childrensId: [],
                entities: [],
                options: [],
                entitiesOriginalLength: 0,
                name: '',
                level: 0,
                levels: {},
                parent_id: "null",
                parent_name: "",
                errors: {
                    name: [],
                    parent: [],
                    isError: false
                },
                showModal: false,
                message: null,
                errorMessages: [],
                responseErrorMessage: '',
                showErrorModal: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData: {
                    name: false,
                    user_email: false,
                    host: false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings-entities');
            await this.getEntities();
            await this.editEntities();
            this.$refs.multiselect.select({value: this.parent_id, label: this.parent_name});
        },
        methods: {
            async confirmModalHandler(event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if (event) {
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/settings/entities');
                }
            },
            async getEntities() {
                try {
                    const response = await repository.index('entities', false, 'asc', false);
                    this.entities = response.data.data;
                    this.options.push({
                        value: "null",
                        label: "parent"
                    });
                    this.entities.forEach((item) => {
                        this.options.push({
                            value: item.id,
                            label: item.name
                        });
                    })
                    for (let i = 0; i < this.entities.length; i++) {
                        this.levels[`${this.entities[i].id}`] = this.entities[i].level;
                    }

                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log(e);
                }
            },

            async editEntities() {
                try {
                    this.id = this.$route.params.id;
                    const response = await repository.show('entities', this.id);
                    this.name = response.data.data.name;
                    this.parent_id = response.data.data.parent_id;
                    if (this.parent_id === null) {
                        this.parent_name = "parent"
                        this.parent_id = "null";
                    }
                    this.childrensId = response.data.data.childrenIds;
                    this.entities = this.entities.filter((entity) => {
                        if (entity['id'] === this.parent_id) {
                            this.parent_name = entity['name'];
                        }
                        return ((entity['id'] != this.id) && !this.childrensId.includes(entity['id']))
                    })
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log(e);
                }
            },

            selectHandler(e) {
                if (e !== null) {
                    this.errors['parent'] = []
                    let perentLevel = e !== "null" ? this.levels[e] : 0;
                    let newChildLevel = perentLevel !== null ? (perentLevel + 1) : 0
                    if (perentLevel !== undefined && newChildLevel >= `${process.env.VUE_APP_TREE_PATH}`) {
                        this.errors['parent'] = ['* Tree is full']
                    } else {

                    }
                } else {
                    this.errors['parent'] = ['*Required']
                }

            },

            async changeHandler(e) {
                await this.checkData();
            },

            checkData() {
                let isError = false;
                if (this.name.length < 1) {
                    this.errors['name'] = ['*Required'];
                    isError = true;
                } else if (this.name.length < 2) {
                    this.errors['name'] = ['* Entity name must be more than 2 characters'];
                    isError = true;
                } else if (this.name.length > 40) {
                    this.errors['name'] = ['* Entity name must be less than 40 characters'];
                    isError = true;
                } else {
                    this.errors['name'] = [];
                }

                if (this.parent_id === null) {

                    this.errors['parent'] = ['*Required'];
                    isError = true;
                } else if (this.errors['parent'].length > 0) {
                    isError = true;
                } else {
                    this.errors['parent'] = [];
                }
                return isError;
            },

            async submitHandler() {

                const error = await this.checkData();
                if (!error) {
                    try {
                        const id = this.$route.params.id;
                        await this.$store.dispatch('setDataFlag', false);
                        const response = await repository.update('entities', this.id, {
                            name: this.name,
                            parent_id: this.parent_id,
                        });

                        if (response.status === 200) {
                            this.showModal = true;
                            this.message = response.data.message;
                            setTimeout(() => {
                                this.$router.push({name: 'entities'});
                            }, 1000);
                        } else {
                            if (process.env.VUE_ENV === 'development')
                                console.log('Something Wrong !');
                        }

                    } catch (e) {
                        if (process.env.VUE_ENV === 'development')
                            console.log(e);
                    }
                } else {
                    await this.$store.dispatch('setDataFlag', true);
                }
            }
        }
    }
</script>

<style scoped>
    .multiselect-style {
        background-color: transparent;
        color: var(--main-color);
        border: 1px solid #04445E;
        height: 50px;
        width: 270px;
    }

    .multiselect-dropdown {
        background-color: transparent !important;
        color: #FFF !important;
    }

    .is-pointed,
    .multiselect-option.is-selected.is-pointed,
    .multiselect-option.is-selected.is-pointed:hover,
    .multiselect-option.is-selected:hover {
        background-color: transparent !important;
    }

    .errorEntityName {
        position: absolute;
    }

    #createEntityContainer {
        padding: 20px;
        height: 70vh;
        overflow-y: auto;
    }


    .custom-input,
    .custom-input:focus {
        width: 250px;
        height: 50px;
        background-color: transparent;
        border: 1px solid #04445E;
        border-radius: 6px;
        color: var(--main-color);
        outline: 0;
        box-shadow: 0 0 0 0;
    }


    .entity-section {
        height: 150px;
        align-items: center;
        border: 1px solid #39525C;
        padding: 20px 10px;
    }

    .entity-input-container {
        height: 75px;
    }

    .err {
        overflow-y: auto;
        height: 170px;
    }

    .custom-input {
        background-color: transparent;
        color: var(--main-color);
    }
</style>